module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt_m.a4d1ae7f39e4025b0fc6847c205917e2.png";